import React, { Component } from 'react'
import { Link } from 'react-router'
import AppBar from 'material-ui/AppBar'
import NavLabels from './NavLabels'
import NavDrawer from '../../containers/NavDrawer'
import img from '../../../public/mm-logo.png'

class NavBar extends Component {
  constructor(props) {
    super(props)
    this.state = {open: false};
  }

  _toggleMenu = () => {
    this.setState({open: !this.state.open})
  }

  _openMenu = () => {
    this.setState({
      open: true
    })
  }

  _closeMenu = (path) => {
    this.setState({
      open: false
    })
  }

  _onRequestChange = (open) => {
    this.setState({
      open: open
    })
  }

  _pushBrowserHistory = (path) => {
    console.log(path)
  }

  render() {
    const { lessThan } = this.props.browser

    return (
      <div className="navbar">
        <AppBar 
          className='first-app-bar'
          title={
            <Link to='/'>
              <img className='logo' src={img} alt='Mind Makers'/>
            </Link>}
          onLeftIconButtonClick={this._openMenu}>
            {!lessThan.large && 
              <NavLabels
              open={this.state.open}
              pushBrowserHistory={this._pushBrowserHistory} 
            /> }
          </AppBar>
        <NavDrawer
          open={this.state.open}
          onClose={this._closeMenu}
          onOpen={this._openMenu}
          onRequestChange={this._onRequestChange}
          onToggle={this._toggleMenu}
        />
      </div>
    )
  }
}

export default NavBar


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js